import React, { useState } from "react";

import { Col, Input, Modal, Row, Tabs, Button, message } from "antd";
import FolderPath from "../folderpath/FolderPath";
import { addVariables } from "../../../service/admin.service";
import { addDBConnection } from "../../../service/db.service";
import DbConnectionsView from "../database/DbConnectionsView";
import { validateDuplicateFolderDisplayNames } from "../../../helper/validation_helper";

function EnvironmentModalView({
  environmentName,
  existingDbDetails,
  existingFolderData,
  updateEnvironmentList,
  isOpen,
  handleModalClose,
}) {
  const [updatedFolderData, setUpdatedFolderData] = useState([]);
  const [updatedDbData, setUpdatedDbData] = useState([]);
  const handleFolderPathUpdate = (data) => {
    console.log("update", data);
    setUpdatedFolderData(data);
  };
  const onClickSave = () => {
    if (!environmentName || environmentName.trim() === "") {
      message.error("Environment name cannot be empty!");
      return;
    }
    if (updatedFolderData.length === 0 && updatedDbData.length === 0) {
      message.error("There is no updates to save");
      return;
    }
    if (updatedFolderData.length === 0) {
      message.warning("No Folder path configured!");
      return;
    }
    if (updatedDbData.length === 0) {
      message.warning("No Database connection configured!");
      return;
    }
    if (updatedFolderData.length > 0) {
      addVariables(updatedFolderData).then((res) => {
        if (res.status !== 200) {
          message.error("Something went wrong!");
        } else {
          updateEnvironmentList();
          message.success("Folder Path Updated!");
        }
        handleModalClose();
      });
    }
    if (updatedDbData.length > 0) {
      addDBConnection(environmentName, updatedDbData)
        .then((addRes) => {
          updateEnvironmentList();
          message.success("Database Connection Updated!");
          handleModalClose();
        })
        .catch((error) => {
          message.error(error);
        });
    }
    if (updatedFolderData.length > 0) {
      const folderNameError = validateDuplicateFolderDisplayNames(
        updatedFolderData,
        existingFolderData || [],
      );
      if (folderNameError) {
        message.error(folderNameError);
        return;
      }
    }
  };
  const updateDbData = (data, displayName) => {
    setUpdatedDbData(data);
  };

  const existingSteps = [
    {
      label: "Folder Path",
      key: 1,
      children: (
        <FolderPath
          environmentName={environmentName}
          initialData={existingFolderData || []}
          onFolderUpdate={handleFolderPathUpdate}
        />
      ),
    },
    {
      label: "Database Connections",
      key: 2,
      children: (
        <DbConnectionsView
          environmentName={environmentName}
          initialData={existingDbDetails || []}
          updateDbDataSource={updateDbData}
        />
      ),
    },
  ];
  return (
    <div>
      <Modal
        open={isOpen}
        destroyOnClose
        maskClosable={false}
        centered
        width="150vh"
        footer={[
          <Button key="back" onClick={onClickSave}>
            Save
          </Button>,
          <Button key="submit" type="primary" onClick={handleModalClose}>
            Cancel
          </Button>,
        ]}
        onCancel={handleModalClose}
      >
        <Row style={{ paddingBottom: "20px" }}>
          <p className="modal-header-text">Manage Environment</p>
        </Row>
        <Row></Row>
        <Row>
          <Col span={6}>
            <p className="spec-modal-label">Environment Name * </p>
          </Col>
          <Col span={18}>
            <Input
              placeholder="environment name"
              value={environmentName}
              disabled
            />
          </Col>
        </Row>

        <Tabs
          defaultActiveKey="1"
          type="card"
          size="small"
          items={existingSteps}
        />
      </Modal>
    </div>
  );
}

export default EnvironmentModalView;
